var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 15,
    viewBox: "0 0 65 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clearspace"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logotype"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1725 8.88088C11.1725 11.9661 8.67142 14.4671 5.58623 14.4671C2.50104 14.4671 0 11.9661 0 8.88088C0 5.79571 2.50104 3.29468 5.58623 3.29468C8.67142 3.29468 11.1725 5.79571 11.1725 8.88088ZM5.58623 11.9843C7.30022 11.9843 8.68969 10.5949 8.68969 8.88088C8.68969 7.1669 7.30022 5.77744 5.58623 5.77744C3.87223 5.77744 2.48277 7.1669 2.48277 8.88088C2.48277 10.5949 3.87223 11.9843 5.58623 11.9843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.2924 0.811896C14.6951 0.810472 14.1216 1.04054 13.6977 1.45166C13.2738 1.86277 13.0342 2.42136 13.0312 3.00489V14.4672L15.514 14.4672V3.33466C15.514 3.33466 15.5184 3.31372 15.5261 3.30616C15.5339 3.2986 15.5443 3.29435 15.5553 3.29435L18.6175 3.29465V0.811896H15.2924Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4144 8.88088C30.4144 11.9661 27.9134 14.4671 24.8282 14.4671C21.743 14.4671 19.2419 11.9661 19.2419 8.88088C19.2419 5.79571 21.743 3.29468 24.8282 3.29468C27.9134 3.29468 30.4144 5.79571 30.4144 8.88088ZM24.8282 11.9843C26.5422 11.9843 27.9316 10.5949 27.9316 8.88088C27.9316 7.1669 26.5422 5.77744 24.8282 5.77744C23.1142 5.77744 21.7247 7.1669 21.7247 8.88088C21.7247 10.5949 23.1142 11.9843 24.8282 11.9843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M34.7579 14.4671H32.2751V0.81189H34.7579V14.4671Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M50.2725 14.467H41.944C41.3568 14.4684 40.793 14.2382 40.3759 13.8268C39.9592 13.4154 39.7235 12.8565 39.7207 12.2726V6.08765H42.1902V11.9768C42.1902 11.9878 42.1945 11.9983 42.2019 12.0063C42.2096 12.0143 42.2198 12.0192 42.2308 12.0198H50.2725V14.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M38.1719 0.812026H46.7439C47.3488 0.809865 47.9296 1.04858 48.3588 1.47573C48.7883 1.90289 49.0309 2.48355 49.034 3.09017V9.50167H46.491V3.38482C46.4904 3.37372 46.4855 3.36331 46.4774 3.35571C46.4694 3.3481 46.4586 3.34388 46.4474 3.3439H38.1719V0.812026Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M64.5498 14.4671H56.2208C55.6337 14.4685 55.07 14.2383 54.6531 13.8269C54.2365 13.4156 54.0008 12.8566 53.998 12.2728V6.08777H56.4697V11.9769C56.4697 11.9879 56.4737 11.9985 56.4814 12.0065C56.4888 12.0145 56.4992 12.0193 56.5103 12.02H64.5498V14.4671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M52.4473 0.812026H61.0217C61.321 0.810964 61.6175 0.869038 61.8945 0.982942C62.1716 1.09685 62.4235 1.26435 62.6358 1.4759C62.8485 1.68744 63.0172 1.93888 63.1326 2.21586C63.2484 2.49283 63.3084 2.78993 63.3094 3.09017V9.50167H60.766V3.38482C60.766 3.37397 60.7617 3.36356 60.7539 3.35589C60.7462 3.34821 60.736 3.3439 60.7252 3.3439H52.4473V0.812026Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLogo);
export default __webpack_public_path__ + "static/media/event_logo.435b430e0387b1dd94e57f72735ebc19.svg";
export { ForwardRef as ReactComponent };